﻿'use strict';

angular.module('ntmApp').factory('RoomSchedulesFilter', ['MultiSelectFilter', 'SimpleFilter', 'Constants', 'RadioButtonChoiceFilter',
    function (MultiSelectFilter, SimpleFilter, Constants, RadioButtonChoiceFilter) {

    function RoomSchedulesFilter() {

        var self = this;

        self.RoomTypeFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoRoomType);
        self.AssignedStaffFilter = new SimpleFilter();

        self.HasUnAssignedFilter = new RadioButtonChoiceFilter(function (item) {

            if (item === 'yes') {
                return 'Has un-assigned activities this week';
            }

            if (item === 'no') {
                return 'Does not have un-assigned activities this week';
            }

            return '';
        });

        self.HasOverAllocatedFilter = new RadioButtonChoiceFilter(function (item) {

            if (item === 'yes') {
                return 'Has over-allocated staff this week';
            }

            if (item === 'no') {
                return 'Does not have over-allocated staff this week';
            }

            return '';
        });

        self.getFilters = function () {
            return [
                self.RoomTypeFilter,
                self.AssignedStaffFilter,
                self.HasUnAssignedFilter,
                self.HasOverAllocatedFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getFilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getFilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.getFilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.isBlockHeaderApplied = function (blockHeader) {

            if (self.RoomTypeFilter.isDefined() && !self.RoomTypeFilter.selectedItems.some(function (roomType) {
                return (roomType.value.trim() === blockHeader.roomType) || (!roomType.id && !blockHeader.roomType);
            })) {
                return false;
            }

            if (self.AssignedStaffFilter.isDefined()) {
                
                var hasAssignee = blockHeader.dowActivityToggles.some(function (dow) {
                    return dow.alertRoomAssignmentTotals && dow.alertRoomAssignmentTotals.some(function (assigment) {
                        return assigment.personId === self.AssignedStaffFilter.filterItem.id;
                    });
                });

                if (!hasAssignee) {
                    return false;
                }
            }

            if (self.HasUnAssignedFilter.isDefined()) {

                var hasUnAssignedActivities = blockHeader.dowActivityToggles.some(function (dow) {
                    return dow.alertUnAssignedActivities;
                });

                if (self.HasUnAssignedFilter.filterItem === 'yes' && !hasUnAssignedActivities) {
                    return false;
                }

                if (self.HasUnAssignedFilter.filterItem === 'no' && hasUnAssignedActivities) {
                    return false;
                }
            }

            if (self.HasOverAllocatedFilter.isDefined()) {

                var hasOverAllocatedStaff = blockHeader.dowActivityToggles.some(function (dow) {
                    return dow.alertOverAllocatedStaffs && dow.alertOverAllocatedStaffs.length > 0;
                });

                if (self.HasOverAllocatedFilter.filterItem === 'yes' && !hasOverAllocatedStaff) {
                    return false;
                }

                if (self.HasOverAllocatedFilter.filterItem === 'no' && hasOverAllocatedStaff) {
                    return false;
                }
            }

            return true;
        };
    }

    return (RoomSchedulesFilter);
}]);